// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3X7tn","title":"Info_title__3pscN","links":"Info_links__b1yU2","link":"Info_link__NNQQY","logo":"Info_logo__1WZh_"};